import { IComponentOptions } from "angular";
import { ContractInstanceFilesComponentController } from "./controller";

export const vsComponentName = "contractInstanceFiles";

export const contractInstanceFilesComponentOptions: IComponentOptions = {
  controller: ContractInstanceFilesComponentController,
  controllerAs: "filesController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contract: "<",
  },
};
